var map = {
	"./case_85x85_sel.png": 2220,
	"./comment_or_report_85x85_sel.png": 7992,
	"./expertise_attachment_85x85_sel.png": 7539,
	"./honorary_note_85x85_sel.png": 9095,
	"./images_85x85_sel.png": 4930,
	"./insured_person_85x85_sel.png": 898,
	"./other_attachments_85x85_sel.png": 4895,
	"./overview_85x85_sel.png": 3837,
	"./policy_85x85_sel.png": 6326,
	"./rim_85x85_sel.png": 986,
	"./svs_85x85_sel.png": 6752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6371;